import { render, staticRenderFns } from "./MessageFooter.vue?vue&type=template&id=29bd77a4&scoped=true&"
import script from "./MessageFooter.vue?vue&type=script&lang=js&"
export * from "./MessageFooter.vue?vue&type=script&lang=js&"
import style0 from "./MessageFooter.vue?vue&type=style&index=0&id=29bd77a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bd77a4",
  null
  
)

export default component.exports